export default __webpack_public_path__ + "static/media/new-stats-preview.6b4c7af6.png";